import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '../../auth/context/AuthContext';

export default function Register() {
  const [searchParams] = useSearchParams();
  const [form, setForm] = useState({
    email: '',
    phone: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const { registerAccount } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (form.password.length < 6) return toast.error('Password must be at least 6 characters');

    setLoading(true);
    try {
      const user = await registerAccount({
        email: form.email,
        phone: form.phone,
        password: form.password,
        referral_code: searchParams.get('ref') || '',
      });

      toast.success(`Welcome in. Your shipping mark is ${user.shipping_mark}.`);
      navigate('/welcome');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  const fields = [
    { label: 'Email Address', key: 'email', type: 'email', placeholder: 'your@email.com' },
    { label: 'Phone Number', key: 'phone', type: 'tel', placeholder: '+233XXXXXXXXX' },
    { label: 'Password', key: 'password', type: 'password', placeholder: 'Minimum 6 characters' },
  ];

  return (
    <div className="auth-page">
      <div className="auth-shell">
        <div className="auth-intro">
          <p className="auth-kicker">Fast registration</p>
          <h1>Create your account in seconds and finish setup inside a guided chat.</h1>
          <p>
            We only ask for your email, phone number, and password here. Right after that, you will
            be signed in and guided through the rest of your setup with Smaiz.
          </p>
        </div>

        <div className="auth-card">
          <div className="auth-card-header">
            <div className="logo">D2D<span>SHIPPING PLATFORM</span></div>
            <p>Start with the basics</p>
          </div>

          <form onSubmit={handleSubmit}>
            {fields.map(({ label, key, type, placeholder }) => (
              <div className="input-group" key={key}>
                <label>{label}</label>
                <input
                  className="input-field"
                  type={type}
                  placeholder={placeholder}
                  value={form[key]}
                  onChange={(event) => setForm({ ...form, [key]: event.target.value })}
                  required
                />
              </div>
            ))}

            <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
              {loading ? <span className="spinner" /> : 'Create Account'}
            </button>
          </form>

          <div className="auth-link-row">
            <p>Already have an account? <Link to="/login">Sign in</Link></p>
            <p><Link to="/">Back to home</Link></p>
          </div>
        </div>
      </div>
    </div>
  );
}
